import { CurrencyValueForm } from 'models/apps'
import { CurrencyMinimalAmount } from 'models/settings'
import { ExchangeDirection } from 'models/exchange-transfer-calculate'

import { localeStringToFloat } from 'utils/format-number'

interface GetIsBelowMinimalAmountParams {
  value: CurrencyValueForm
  direction?: ExchangeDirection
  minimalAmounts: CurrencyMinimalAmount[]
  baseCurrency: string
  counterCurrency: string
  activeCurrency?: string
}

export const getIsBelowMinimalAmount = ({
  value,
  direction = 'forward',
  minimalAmounts,
  baseCurrency,
  counterCurrency,
  activeCurrency,
}: GetIsBelowMinimalAmountParams): boolean => {
  const currencyToCheck = activeCurrency || (direction === 'forward' ? baseCurrency : counterCurrency)
  const activeMinimal = minimalAmounts.find((a) => a.currency === currencyToCheck)?.minimal_local
  const numericValue = Number(localeStringToFloat(value.currentValue))
  return numericValue < Number(activeMinimal || 0)
}

/** Minimal amount value for the currency shown in the "amount too low" message. */
export const getMinimalAmountForCurrency = (minimalAmounts: CurrencyMinimalAmount[], currency: string): string =>
  minimalAmounts.find((a) => a.currency === currency)?.minimal_local || '0'
